/* ************************* events actions reducer ************************* */
// dependencies
import { toast } from "react-toastify";
import API from "../../Api/Api";
import qs from "qs";
import {
  EVENTS_FETCHED,
  EVENTS_LOADING,
  EVENT_LOADING,
  EVENT_UPDATED,
  EVENT_FETCHED,
  CREATED_EVENT_LOADING,
  CREATED_EVENT_SUCCESS,
  DELETE_EVENT,
} from "../reducer/events";
import { closeRightModal } from "./rightModal";
import { eventTypeFr } from "../../Utils/fileUtils";
import { uploadFile } from "../../Utils";
// get Events
export const getEvents = (signal) => async (dispatch, getState) => {
  const { user } = getState().userReducer;
  dispatch({ type: EVENTS_LOADING });
  let filters = {};
  if (user?.attributes?.userRole === 0) {
    const resellerId =
      user?.attributes?.profil?.data?.attributes?.reseller?.data?.id;
    filters = {
      $or: [
        {
          resellers: {
            id: {
              $eq: resellerId,
            },
          },
        },
        {
          resellers: {
            id: {
              $null: true,
            },
          },
        },
      ],
    };
  } else if (user?.attributes?.userRole === 2) {
    const businessAffiliateId = user?.attributes?.business_affiliate?.data?.id;
    filters = {
      $or: [
        {
          resellers: {
            business_affiliate: {
              id: { $eq: businessAffiliateId },
            },
          },
        },
        {
          resellers: {
            id: {
              $null: true,
            },
          },
        },
      ],
    };
  }
  const query = qs.stringify({
    fields: [
      "title",
      "startDate",
      "endDate",
      "startTime",
      "endTime",
      "eventType",
      "visitLink",
      "description",
      "isGlobal",
    ],
    populate: {
      Image: { fields: ["url"] },
      creator: {
        populate: {
          profil: {
            populate: {
              reseller: {
                populate: {
                  business_affiliate: true,
                },
              },
            },
          },
        },
      },
    },
    filters,
  });
  try {
    const { data: events } = await API.get(`api/events?${query}`, { signal });
    dispatch({ type: EVENTS_FETCHED, payload: events });
  } catch (err) {
    console.log(err);
    toast.error();
  }
};
// create event action :
export const createEvent = (payload, t) => async (dispatch, getState) => {
  const { user } = getState().userReducer;
  const { newEvent } = payload;
  dispatch({ type: CREATED_EVENT_LOADING });
  const query = qs.stringify({
    populate: {
      Image: { fields: ["url"] },
    },
  });

  try {
    let uploadedImageId = null;
    if (newEvent.photo) {
      uploadedImageId = await uploadFile(newEvent.photo);
    }

    let uploadedDocumentId = null;
    if (newEvent.document) {
      uploadedDocumentId = await uploadFile(newEvent.document);
    }

    const { data: createdEvent } = await API.post(`/api/events?${query}`, {
      data: {
        ...newEvent,
        eventType: newEvent?.eventType?.code,
        Image: uploadedImageId,
        document: uploadedDocumentId,
        creator: user?.id,
      },
    });

    dispatch({ type: CREATED_EVENT_SUCCESS, payload: createdEvent.data });
    dispatch(closeRightModal());
    toast.success(
      `${t(`${eventTypeFr[newEvent.eventType?.code]}`)} ${t(
        `successfully created!`,
        {
          ns: "common",
        },
      )}`,
    );
  } catch (error) {
    console.log(error, "error");
    toast.error(
      t(`An error has occurred!`, {
        ns: "common",
      }),
    );
  }
};
// getSingleEvent action:
export const getSingleEvent = (eventId) => async (dispatch) => {
  dispatch({ type: EVENT_LOADING });
  const query = qs.stringify({
    fields: [
      "title",
      "startDate",
      "endDate",
      "startTime",
      "endTime",
      "eventType",
      "visitLink",
      "description",
      "budget",
      "spa_sold",
      "swim_spa_sold",
      "quotes_count",
      "isGlobal",
    ],
    populate: {
      Image: { fields: ["url", "name"] },
      document: { fields: ["url", "name"] },
      resellers: { populate: true },
      creator: {
        populate: {
          profil: {
            populate: {
              reseller: {
                populate: {
                  business_affiliate: true,
                },
              },
            },
          },
        },
      },
    },
  });

  try {
    const { data: singleEvent } = await API.get(
      `api/events/${eventId}?${query}`,
    );

    dispatch({
      type: EVENT_FETCHED,
      payload: singleEvent,
    });
  } catch (err) {
    toast.error("Erreur lors de la récupération de l'événement.");
  }
};
// delete event :
export const deleteEvent = (eventId, eventType, t) => async (dispatch) => {
  try {
    await API.delete(`/api/events/${eventId}`);
    dispatch({ type: DELETE_EVENT, payload: eventId });
    dispatch(closeRightModal());
    toast.success(
      `${t(`${eventTypeFr[eventType] ?? ""}`)} ${t("successfully deleted!")}`,
    );
  } catch (error) {
    console.log(error, "error");
    toast.error(t("An error occurred while deleting the event."));
  }
};

export const updateEvent = (payload, t) => async (dispatch) => {
  const { updatedEvent, eventId } = payload;
  try {
    dispatch({ type: EVENT_LOADING });
    let uploadedImageId = null;
    if (updatedEvent.newPhoto) {
      uploadedImageId = await uploadFile(updatedEvent.newPhoto);
    }
    if (uploadedImageId) {
      updatedEvent.Image = uploadedImageId;
    } else {
      updatedEvent.Image = updatedEvent?.Image.data?.id;
    }

    let uploadedDocumentId = null;
    if (updatedEvent.newDocument) {
      uploadedDocumentId = await uploadFile(updatedEvent.newDocument);
    }
    if (uploadedDocumentId) {
      updatedEvent.document = uploadedDocumentId;
    } else {
      updatedEvent.document = updatedEvent?.document.data?.id;
    }

    await API.put(`api/events/${eventId}`, {
      data: {
        ...updatedEvent,
        eventType: updatedEvent?.eventType?.code,
      },
    });
    dispatch({ type: EVENT_UPDATED });
    dispatch(getEvents());
    dispatch(closeRightModal());
    toast.success(t("Event successfully updated"));
  } catch (error) {
    console.log(error);
  }
};
